import { Routes } from '@angular/router';
import { SettingsComponent } from './settings/settings.component';

export const SettingRoutingModule: Routes = [{ path: 'settings', component: SettingsComponent }];
